
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up/athlete",
      function () {
        return require("private-next-pages/sign-up/athlete.js");
      }
    ]);
  